// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"az_Nhc"};